import { setViewportFullHeight } from 'nove8/helpers/setViewportFullHeight'
import { useAxonPixelEvent } from 'nove8/hooks/useAxonPixelInitialization'
import { useScrollFix } from 'nove8/hooks/useScrollFix'
import { useDestroyBeforeUnmountComponent } from 'nove8/hooks/useDestroyBeforeUnmountComponent'
import { useInitFirebase } from 'nove8/hooks/useInitFirebase'
import { useInitGrowthbook } from 'nove8/hooks/useInitGrowthbook'
import { useInitialSetSearchParamsToSessionStore } from 'nove8/hooks/useInitialSetSearchParamsToSessionStore'
import { useRestorePurchaseFromSearchParams } from 'nove8/hooks/payment/useRestorePurchaseFromSearchParams'
import { useSnapPixelInitialization } from 'nove8/hooks/useSnapPixelInitialization'
import React, { Suspense } from 'react'
import { routeHistory } from 'route-history'
import { polyfill as smoothScrollPolyfill } from 'smoothscroll-polyfill'
import { Spinner } from './components/Spinner'
import { CustomRouter } from './CustomRouter'
import { SubscribeFlow } from './SubscribeFlow'

setViewportFullHeight()
smoothScrollPolyfill()

export const App: React.FC = () => {
  useRestorePurchaseFromSearchParams()
  useInitFirebase()
  useInitGrowthbook()
  useInitialSetSearchParamsToSessionStore()
  useScrollFix()
  useSnapPixelInitialization()
  useAxonPixelEvent()
  useDestroyBeforeUnmountComponent()

  return (
    <CustomRouter history={routeHistory}>
      <Suspense fallback={<Spinner />}>
        <SubscribeFlow />
      </Suspense>
    </CustomRouter>
  )
}
